import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";
import { CONTACT_INFO, COMPANIES } from "@/data/companies";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-950 text-slate-300"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" data-testid="footer-logo-link" className="flex items-baseline gap-1.5">
              <span className="font-heading text-xl font-extrabold tracking-tight text-white">
                AMS
              </span>
              <span className="font-heading text-xl font-light tracking-tight text-slate-400">
                Venture Holdings
              </span>
            </Link>
            <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-sm">
              A Canadian holding company based in Edmonton, Alberta, owning and
              operating specialized service businesses built on trust and
              professionalism.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-white uppercase tracking-wider">
              Company
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About" },
                { to: "/companies", label: "Our Companies" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-slate-400 hover:text-white transition-colors duration-200"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-semibold text-white uppercase tracking-wider">
              Get in touch
            </h4>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={17} className="mt-0.5 text-blue-400 shrink-0" />
                <span className="text-slate-400">{CONTACT_INFO.location}</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={17} className="mt-0.5 text-blue-400 shrink-0" />
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  data-testid="footer-email-link"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  {CONTACT_INFO.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} AMS Venture Holdings Inc. All rights
            reserved.
          </p>
          <p className="text-xs text-slate-500">
            {COMPANIES.map((c) => c.name).join(" · ")}
          </p>
        </div>
      </div>
    </footer>
  );
};
